const normalizeToUtc = (input: string) => {
  if (input.length === 19) return input + 'Z';
  if (!input.endsWith('Z')) return input + 'Z';
  return input;
};

export const formatDate = (date?: string | null) => {
  if (!date) return '';
  if (typeof date !== 'string') return `${date}`;

  if (date.length === 19) {
    return date.replace('T', ' ');
  }

  const normalizedDate = normalizeToUtc(date);
  const parsedDate = new Date(normalizedDate);
  if (isNaN(parsedDate.getTime())) return '';

  return parsedDate.toISOString().replace('T', ' ').replace('Z', '');
};
